module.exports = {
    routes: [
        {
            name: 'auth.password.reset',
            path: '/password/reset',
            component: require('./pages/ResetPassword').default,
        },
        {
            name: 'auth.password.request',
            path: '/password/request',
            component: require('./pages/RequestReset').default,
        },
    ],
};



// WEBPACK FOOTER //
// ./src/infrastructure/auth/routes.js